import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setToken, setUser, setRegistration } from "../redux/slices/userSlice";
import { Link, useNavigate } from "react-router-dom";
import { posible_bg, posible_logo } from "../config/imageImport";
import { loginUser } from "../api/auth";
import { toast } from "react-toastify";
import Input from "../components/controls/Input";
import Button from "../components/controls/Button";
import { fetchStore } from "../api/storeApi";
import { setStore, setStoresList } from "../redux/slices/storeSlice";
import Icon from "../assets/icons/Icon";
import { fetchRegistration } from "../api/RegistrationApi";
import { setAcl } from "../redux/slices/aclSlice";
import AxiosAPI from "../api/AxiosAPI";
import axios from "axios";
import { fetchPrintConfig } from "../api/printConfigApi";
import { setPrintConfig } from "../redux/slices/printConfigSlice";
import { fetchReportConfig } from "../api/ReportApi";
import { setReportConfig } from "../redux/slices/reportConfigSlice";
import { fetchCustomField } from "../api/CustomFieldsApi";
import { setAllModules } from "../redux/slices/customFieldSlice";
import { isMobileView, saveFcmTokenData, saveLoginRecordData } from "../components/controls/CommonFunctions";
import { fetchAllStoreLocation } from "../api/storeLocationApi";
import { setStoreLocations } from "../redux/slices/storeLocationSlice";// Create this component
import { selectUser } from "../redux/slices/userSlice";
import { fetchAcl } from "../api/UserApi";
import SignInLoading from "../components/controls/SignInLoading";
import { generateFcmToken } from "../../fcmService";
const Login = () => {
  const [loginId, setloginId] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ loginId: "", password: "" });
  const [loginIDError, setLoginIDError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [showLoginPage, setShowLoginPage] = useState(true); // New state
  const [postLoginLoading, setPostLoginLoading] = useState(false); // New state
  const [loadingMessage, setLoadingMessage] = useState("Signing in..."); // New state

  const token = useSelector((state) => state.user.token);
    const userdata = useSelector((state) => state.user.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    let loginIDError = "";
    let passwordError = "";
    if (!loginId) {
      loginIDError = "Please enter loginID";
    }
    if (!password) {
      passwordError = "Please enter password";
    }
    if (loginIDError || passwordError) {
      setLoginIDError(loginIDError);
      setPasswordError(passwordError);
      return;
    }

    localStorage.removeItem("reduxState");

    try {
      setLoading(true);
      setLoadingMessage("Signing in...");

      // ✅ Login API call
      console.log("🚀 User not found in cache, fetching from API...");
      const data = await loginUser({ loginId, password, "version": ['1.1.22', "1.1.28"] });

      if (data?.token) {
        // Hide login page and show loader
        setShowLoginPage(false);
        setPostLoginLoading(true);

        // Dispatch token and user
        dispatch(setToken(data.token));
        dispatch(setUser(data.UserProfile));

        // Fetch registration data
        setLoadingMessage("Loading registration data...");
        const registrationResponse = await fetchRegistration({
          regID: data.UserProfile.RegistrationID,
        });
        dispatch(setRegistration(registrationResponse.registration));

        // Fetch custom fields
        setLoadingMessage("Loading custom fields...");
        try {
          const customFieldResponse = await fetchCustomField();
          const customFields = customFieldResponse?.customFields || [];

          const modulesData = {
            customer: customFields.find((item) => item.ModuleName === "Customer") || {},
            product: customFields.find((item) => item.ModuleName === "Product") || {},
            store: customFields.find((item) => item.ModuleName === "Store") || {},
            employee: customFields.find((item) => item.ModuleName === "Employee") || {},
            sales: customFields.find((item) => item.ModuleName === "Sales") || {},
            vendor: customFields.find((item) => item.ModuleName === "Vendor") || {},
          };

          dispatch(setAllModules(modulesData));
        } catch (customFieldError) {
          if (customFieldError.response?.status === 404) {
            console.warn("⚠️ Custom field API returned 404, continuing login...");
            dispatch(setAllModules({
              customer: {},
              product: {},
              store: {},
              employee: {},
              sales: {},
              vendor: {},
            }));
          }
        }

        // Fetch report config and store locations
        setLoadingMessage("Loading configurations...");
        const [reportConfigs, storeLocations] = await Promise.all([
          fetchReportConfigData(),
          fetchAllStoreLocationData()
        ]);

        dispatch(setReportConfig(reportConfigs));
        dispatch(setStoreLocations(storeLocations));

        // Fetch store data
        setLoadingMessage("Loading store data...");
        await fetchAndStoreData(data.token,data.UserProfile);

      }
    } catch (error) {
      console.error("❌ Login Error:", error);
      toast.error(error.response?.data?.message || "Login failed!");
      // Reset states if login fails
      setShowLoginPage(true);
      setPostLoginLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const fetchPrintConfigData = async (storeID) => {
    try {
      const response = await fetchPrintConfig(storeID);
      if (response?.code == "0") {
        const filterData = response.printConfigs.filter(
          (printConfig) => !printConfig?.IsDeleted
        );
        return filterData;
      }
      return [];
    } catch (error) {
      console.log("error", error);
      toast.error("Runtime error occurred!");
      return [];
    }
  };

  const fetchReportConfigData = async () => {
    try {
      const response = await fetchReportConfig();
      if (response?.code == "0") {
        return response.data;
      }
      return [];
    } catch (error) {
      console.log("error", error);
      toast.error("Runtime error occurred!");
      return [];
    }
  };

  const fetchAllStoreLocationData = async () => {
    try {
      const response = await fetchAllStoreLocation();
      if (response?.code == "0") {
        return response.locationData;
      }
      return [];
    } catch (error) {
      console.log("error", error);
      toast.error("Runtime error occurred!");
      return [];
    }
  };

  const fetchAclData = async (storeid, token,UserProfile) => {
    try {
      setLoadingMessage("Loading access permissions...");
      //       const state = store.getState();
      // const userdata = selectUser(state);
    const res=await fetchAcl(storeid);
      // const res = await axios.get(
      //   `https://posibleapi-uat-789032243296.asia-south1.run.app/v2/user/access?storeid=${storeid}`,
      //   {
      //     headers: {
      //       Authorization: `Bearer ${token}`,
      //       "Content-Type": "application/json",
      //       // version: "1.1.22",
      //       version:UserProfile?.EnablePosBillingForPincode
      //       ? "1.1.28"
      //         : "1.1.22"
      //     },
      //   }
      // );

      const aclModules = res.modules;
      dispatch(setAcl(aclModules));

      // Final step - hide loader and navigate
      setTimeout(() => {
        setPostLoginLoading(false);
        navigate("/home");
      }, 500);

    } catch (err) {
      console.log(err, "while fetching the acl");
      toast.error("Error loading permissions");
      setPostLoginLoading(false);
      setShowLoginPage(true);
    }
  };

  // const saveFcmTokenData=async(userProfile,store)=>{
  //     const token = await generateFcmToken();

  // if (!token) return;
  //  const response=await saveFcmToken(token,userProfile?.key,store?.key,userProfile?.RegistrationID,"")

  // }

  const fetchAndStoreData = async (token,UserProfile) => {
    try {
      setLoadingMessage("Fetching store information...");
      const storeData = await fetchStore();
 dispatch(setStoresList(storeData.stores));
      if (storeData?.stores?.length > 1) {
       
        setPostLoginLoading(false);
        navigate("/store-selection", { replace: true });
      } else if (storeData?.stores?.length === 1) {
                await saveLoginRecordData(storeData.stores[0],UserProfile);
        dispatch(setStore(storeData.stores[0]));
          await saveFcmTokenData(storeData.stores[0],UserProfile);
        setLoadingMessage("Loading print configurations...");
        const printConfigs = await fetchPrintConfigData(storeData.stores[0].key);
        dispatch(setPrintConfig(printConfigs));

        await fetchAclData(storeData.stores[0].key, token,UserProfile);
      } else {
        toast.error("No stores found");
        setPostLoginLoading(false);
        setShowLoginPage(true);
      }
    } catch (error) {
      console.error("Error fetching store data:", error);
      toast.error("Error loading store data");
      setPostLoginLoading(false);
      setShowLoginPage(true);
    }
  };

  return (
    <>
      {/* Post-login Loading Overlay */}
      {postLoginLoading && (
        <SignInLoading message={loadingMessage} />
      )}

      {/* Login Page - Conditionally Render */}
      {showLoginPage && (
        <div className={`${isMobileView() ? "h-[100dvh] px-6" : "min-h-screen py-12"} flex items-center justify-center lg:px-8 relative overflow-hidden login-purple-diagonal-gradient `}>
          {!isMobileView() && (
            <>
              <div className="absolute w-[300px] h-[300px] rounded-full bg-white/10 top-[10%] left-[10%] animate-[float_8s_infinite_ease-in-out] z-100"></div>
              <div className="absolute w-[200px] h-[200px] rounded-full bg-white/10 bottom-[20%] right-[15%] animate-[float_8s_infinite_ease-in-out] z-100 animation-delay-[2s]"></div>
              <div className="absolute w-[150px] h-[150px] rounded-full bg-white/10 bottom-[10%] left-[20%] animate-[float_8s_infinite_ease-in-out] z-100 animation-delay-[4s]"></div>
            </>
          )}

          <div className="p-4 py-17 flex flex-col gap-5 w-100 px-5 rounded-2xl backdrop-blur-sm bg-[rgba(255,255,255,0.85)] shadow-[0_15px_35px_rgba(0,0,0,0.2)]">
            <img src={posible_logo} alt="posible logo" className="w-54 mx-auto" />

            <form onSubmit={handleLogin} className="flex flex-col gap-8">
              <Input
                label="Login ID"
                type="text"
                placeholder="Enter your login ID"
                value={loginId}
                onChange={(e) => {
                  setloginId(e.target.value);
                  setLoginIDError("");
                }}
                errorMessage={loginIDError}
                starttext={
                  <span className="w-5">
                    <Icon type="email" />
                  </span>
                }
              />
              <Input
                label="Password"
                type="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setPasswordError("");
                }}
                errorMessage={passwordError}
                starttext={
                  <span className="w-5">
                    <Icon type="lock" />
                  </span>
                }
              />

              <Button submit="true" type="primary" loading={loading}>
                Sign in
              </Button>
            </form>
            <Link
              to="/forgot-password"
              className="text-[#6e2d90] font-normal hover:underline mx-auto"
            >
              Forgot Password
            </Link>
          </div>

          <style>{`
            @keyframes float {
              0% { transform: translateY(0px) rotate(0deg); }
              50% { transform: translateY(-20px) rotate(5deg); }
              100% { transform: translateY(0px) rotate(0deg); }
            }
            .animation-delay-2000 {
              animation-delay: 2s;
            }
            .animation-delay-4000 {
              animation-delay: 4s;
            }
          `}</style>
        </div>
      )}
    </>
  );
};

export default Login;